import { createContext, useContext } from "react";
import { useSeller } from "../users";
import api from "../../services";
import { toast } from "react-toastify";
import { useTenant } from "../tenant";
import { IProviderProps } from "../tenant/tenant.interfaces";
import { IUpdateAdminRole } from "./roles.interface";
export const RoleContext = createContext<any | null>(null);

export const RoleProvider = ({ children }: IProviderProps) => {
  const { token, setApiLoading, getAllSellers } = useSeller();
  const { getTenantUsers } = useTenant();
  const adminUpdateRole = async (
    setModalChangeRole: React.Dispatch<React.SetStateAction<boolean>>,
    data: IUpdateAdminRole
  ) => {
    setApiLoading(true);
    const updated = await api
      .patch(`/roles/user`, data, {
        headers: { Authorization: `Bearer ${token}` },
      })
      .then(async (res) => {
        setApiLoading(false);
        setModalChangeRole(false);
        return true;
      })
      .catch((err) => {
        setApiLoading(false);
        console.log(err.response.data.message);
        toast.error(err.response.data.message);
        return false;
      });

    if (updated) {
      setTimeout(async () => {
        await getTenantUsers();
        await getAllSellers();
      }, 100);
    }
  };

  const adminDisableUser = async (id: String) => {
    setApiLoading(true);
    const updated = await api
      .patch(
        `/users/disable/${id}`,
        {},
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      )
      .then(async (res) => {
        setApiLoading(false);

        return true;
      })
      .catch((err) => {
        setApiLoading(false);
        console.log(err.response.data.message);
        toast.error(err.response.data.message);
        return false;
      });

    if (updated) {
      setTimeout(async () => {
        await getTenantUsers();
        await getAllSellers();
      }, 100);
    }
  };

  const adminEnableUser = async (id: String) => {
    setApiLoading(true);
    const updated = await api
      .patch(
        `/users/enable/${id}`,
        {},
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      )
      .then(async (res) => {
        setApiLoading(false);

        return true;
      })
      .catch((err) => {
        setApiLoading(false);
        console.log(err.response.data.message);
        toast.error(err.response.data.message);
        return false;
      });

    if (updated) {
      setTimeout(async () => {
        await getTenantUsers();
        await getAllSellers();
      }, 100);
    }
  };
  return (
    <RoleContext.Provider
      value={{ adminUpdateRole, adminEnableUser, adminDisableUser }}
    >
      {children}
    </RoleContext.Provider>
  );
};

export const useRole = () => useContext(RoleContext);
